module.exports = __webpack_public_path__ + "static/media/user-icon.21f8f506.svg";